export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PersonTile.vue?vue&type=template&id=dd22d0fa&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PersonTile.vue?vue&type=template&id=dd22d0fa&scoped=true
// module id = 283
// module chunks = 0